import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import { PopupComponentContainer } from './styled';
export var PopupComponent = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(PopupComponentContainer, _extends({}, props, {
    "data-testId": 'confluence-search-datasource-popup-container',
    ref: ref
  }));
});